import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import OrganizationStructure from "../shared/OrganizationStructure";

const ProfilKerjaSamaInternasionalContent: React.FC = () => {
  const organizationUnits = [
    {
      name: "Bagian Perjanjian Internasional",
      abbreviation: "Bag PI",
      description:
        "Bagian Perjanjian Internasional bertugas menyelenggarakan perencanaan, perancangan, penyusunan, konsultasi bilateral, penandatanganan, ratifikasi, dan monitoring pelaksanaan perjanjian internasional di bidang kepolisian.",
      subUnits: [
        {
          name: "Subbag Amerika",
          description:
            "Mengelola perjanjian internasional dengan negara-negara di wilayah Amerika",
        },
        {
          name: "Subbag Eropa",
          description:
            "Mengelola perjanjian internasional dengan negara-negara di wilayah Eropa",
        },
        {
          name: "Subbag Asia Pasifik",
          description:
            "Mengelola perjanjian internasional dengan negara-negara di wilayah Asia Pasifik",
        },
        {
          name: "Subbag Afrika & Timur Tengah",
          description:
            "Mengelola perjanjian internasional dengan negara-negara di wilayah Afrika dan Timur Tengah",
        },
        {
          name: "Urusan Administrasi (Urmin)",
          description: "Pengelolaan administrasi bagian",
        },
      ],
    },
    {
      name: "Bagian Konferensi Internasional",
      abbreviation: "Bagkonferin",
      description:
        "Bagkonferin bertugas melaksanakan penyelenggaraan pertemuan internasional kepolisian baik di dalam negeri dan di luar negeri.",
      subUnits: [
        {
          name: "Subbag Multilateral",
          description:
            "Mengelola pertemuan internasional yang melibatkan banyak negara",
        },
        {
          name: "Subbag Bilateral",
          description: "Mengelola pertemuan internasional antara dua negara",
        },
        {
          name: "Urusan Administrasi (Urmin)",
          description: "Pengelolaan administrasi bagian",
        },
      ],
    },
    {
      name: "Bagian Perwakilan Internasional",
      abbreviation: "Bagwakinter",
      description:
        "Bagwakinter bertugas melaksanakan perencanaan, perintisan, pengelolaan, pembinaan teknis dan analisis dan evaluasi terhadap perwakilan Polri di luar negeri serta melaksanakan kerja sama dan koordinasi dengan perwakilan/LO kepolisian negara asing dan/atau organisasi internasional yang bertugas di Indonesia.",
      subUnits: [
        {
          name: "Subbag LO Asing",
          description:
            "Mengelola koordinasi dengan Liaison Officer kepolisian negara asing di Indonesia",
        },
        {
          name: "Subbag Perwakilan Polri di Luar Negeri (PPLN)",
          description:
            "Mengelola perwakilan Polri yang bertugas di luar negeri",
        },
        {
          name: "Urusan Administrasi (Urmin)",
          description: "Pengelolaan administrasi bagian",
        },
      ],
    },
  ];

  const OverviewContent = () => (
    <div className="p-8">
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-bold mb-4">
          Biro Kerja Sama Internasional (Rokersin)
        </h2>

        <div className="space-y-4 text-base-content/70">
          <p className="leading-relaxed">
            1. Rokersin merupakan unsur pelaksana utama yang berada di bawah
            Kadivhubinter Polri;
          </p>

          <p className="leading-relaxed">
            2. Rokersin bertugas membina, melaksanakan, mengawasi dan
            mengendalikan penyelenggaraan kerja sama internasional secara
            bilateral, regional maupun multilateral melalui perjanjian
            internasional, pertemuan internasional dan perwakilan Polri di luar
            negeri, perwakilan kepolisian/penegak hukum negara asing yang
            bertugas di Indonesia dan membantu pelaksanaan pelindungan hukum
            terhadap warga negara Indonesia di luar negeri;
          </p>

          <div>
            <p className="leading-relaxed mb-2">
              3. Dalam melaksanakan tugas, Rokersin menyelenggarakan fungsi:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2">
              <li>
                (a) perencanaan, penyusunan, pengelolaan, monitoring dan
                evaluasi penyelenggaraan perjanjian internasional dengan lembaga
                negara, lembaga pemerintah maupun lembaga non pemerintah serta
                lembaga organisasi Internasional dan lembaga organisasi non
                pemerintah/swadaya masyarakat yang bersifat bilateral, regional
                dan multilateral;
              </li>
              <li>
                (b) perencanaan, pelaksanaan dan evaluasi penyelenggaraan
                pertemuan internasional baik yang bersifat bilateral, regional
                dan multilateral;
              </li>
              <li>
                (c) perencanaan, pengelolaan, pembinaan teknis dan evaluasi
                terhadap penyelenggaraan tugas Perwakilan Polri di Luar Negeri
                (PPLN);
              </li>
              <li>
                (d) pelaksanaan koordinasi dengan perwakilan kepolisian/penegak
                hukum negara asing (Liasion Officers/LO) yang bertugas di
                Indonesia dalam kerja sama penanggulangan kejahatan
                transnasional dan pengembangan kapasitas; dan
              </li>
              <li>
                (e) pelaksanaan pelindungan hukum terhadap warga negara
                Indonesia di luar negeri;
              </li>
            </ul>
          </div>

          <p className="leading-relaxed font-medium">
            Dalam melaksanakan tugas dan tanggung jawab, Biro Kerja Sama
            Internasional dibantu oleh 3 (tiga) bagian utama dan 1 urusan tata
            usaha.
          </p>
        </div>
      </div>
    </div>
  );

  const FunctionsContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        <div className="bg-base-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-base-content mb-4">
            Fungsi Bagian Perjanjian Internasional
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-base-content/70">
            <li className="leading-relaxed">
              perencanaan dan perancangan perjanjian internasional di bidang
              kepolisian sesuai dengan kebutuhan dan kepentingan nasional
              Indonesia;
            </li>
            <li className="leading-relaxed">
              pelaksanaan konsultasi bilateral dan multilateral dalam rangka
              penyusunan dan negosiasi perjanjian internasional di bidang
              kepolisian;
            </li>
            <li className="leading-relaxed">
              koordinasi proses penandatanganan dan ratifikasi perjanjian
              internasional di bidang kepolisian sesuai dengan prosedur hukum
              yang berlaku;
            </li>
            <li className="leading-relaxed">
              monitoring dan evaluasi pelaksanaan perjanjian internasional di
              bidang kepolisian untuk memastikan implementasi yang efektif;
            </li>
          </ol>
        </div>

        <div className="bg-base-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-base-content mb-4">
            Fungsi Bagian Konferensi Internasional
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-base-content/70">
            <li className="leading-relaxed">
              perencanaan, pelaksanaan dan pelaporan penyelenggaraan pertemuan
              internasional di dalam negeri dan di luar negeri;
            </li>
            <li className="leading-relaxed">
              pelaksanaan koordinasi dengan satuan kerja Polri dan/atau
              Kementerian/Lembaga terkait dalam rangka penyelenggaraan pertemuan
              internasional di dalam negeri dan luar negeri;
            </li>
          </ol>
        </div>

        <div className="bg-base-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-base-content mb-4">
            Fungsi Bagian Perwakilan Internasional
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-base-content/70">
            <li className="leading-relaxed">
              perencanaan, perintisan, pengelolaan, dan pembinaan teknis serta
              analisis dan evaluasi perwakilan Polri di luar negeri;
            </li>
            <li className="leading-relaxed">
              pelaksanaan koordinasi dengan LO kepolisian negara asing, aparat
              penegak hukum negara asing dan organisasi internasional yang
              ditugaskan di Indonesia dalam rangka peningkatan kerja sama
              pencegahan dan pemberantasan kejahatan transnasional/internasional
              serta pengembangan kapasitas;
            </li>
            <li className="leading-relaxed">
              pelaksanaan supervisi dan verifikasi pada perwakilan Polri di luar
              negeri;
            </li>
            <li className="leading-relaxed">
              pelaksanaan analisis dan evaluasi tugas perwakilan Polri di luar
              negeri;
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "📋",
      component: <OverviewContent />,
    },
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: (
        <OrganizationStructure
          mainTitle="Struktur Organisasi Biro Kerja Sama Internasional"
          mainDescription="Biro Kerja Sama Internasional dibantu oleh 3 (tiga) bagian utama dan 1 urusan tata usaha dalam melaksanakan tugas dan tanggung jawab."
          units={organizationUnits}
        />
      ),
    },
    {
      id: "functions",
      label: "Tugas & Fungsi",
      icon: "⚙️",
      component: <FunctionsContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Profil Biro Kerja Sama Internasional"
      subtitle="ROKERSIN"
      icon="🤝"
      breadcrumbBase="Kerja Sama Internasional"
      tabs={tabs}
      footerTitle="Biro Kerja Sama Internasional"
      footerDescription="Membina dan melaksanakan kerja sama internasional untuk mendukung tugas Polri dalam pencegahan dan pemberantasan kejahatan transnasional."
      footerStats={[
        { label: "Bagian Utama", value: "3" },
        { label: "Sub Bagian", value: "11" },
        { label: "Wilayah Kerja", value: "Global" },
      ]}
    />
  );
};

export default ProfilKerjaSamaInternasionalContent;
